import { render, staticRenderFns } from "./ExchangeProduct.vue?vue&type=template&id=8181831c&"
import script from "./ExchangeProduct.vue?vue&type=script&lang=ts&"
export * from "./ExchangeProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports